import { get, post, put, postFile } from "./lib/http";

function getMailCode(mail, cb) {
    post("/auth/mail/code", { mail: mail, requestId: generateRequestId(mail) }, cb)
}

function usesPasswordLogin(mail, cb){
    post("/auth/usesPasswordLogin", { mail: mail }, cb)
}

function oidcLogin(providerconfigs, provider, code, cb) {
    post("/auth/login", { provider: provider, code: code, redirectOrMail: providerconfigs[provider].redirect }, cb)
}
function mailCodeLogin(mail, code, cb) {
    post("/auth/login", { provider: "mailcode", code: code, redirectOrMail: mail }, cb)
}
function mailPasswordLogin(mail, password, cb) {
    post("/auth/login", { provider: "mailpassword", password: password, redirectOrMail: mail }, cb)
}
function checkUser(cb) {
    get("/user", cb)
}
function getCards(cb) {
    get("/cards", cb)
}
function checkRFID(data, cb) {
    post("/rfidcheck", data, cb, false)
}
function logout(cb) {
    post("/auth/logout", {}, cb)
}

function getMealPlanForWeek(contract, year,cw,cb){
    get("/contracts/"+contract+"/mealplan/"+year+cw,cb)
}

function getMealsForWeek(contract, year,cw,cb){
    get("/contracts/"+contract+"/mealplan2/"+year+cw,cb)
}
function getMealPlanConfig(project, week,cb){
    get("/mealplan/config/"+project+"/"+week,cb)
}

function saveMealPlanForWeek(contract, year,cw,data,cb){
    post("/contracts/"+contract+"/mealplan/"+year+cw,data,cb)
}

function getQRCode(id, cb) {
    get("/cards/" + id+"/qr", cb)
}

function getEatingContracts(cb) {
    get("/mealplan/contracts", cb)
}

function getPickupContracts(cb) {
    get("/attendance/contracts", cb)
}

function getMealPlanForMonitor(project,cb){
    get("/mealplan/forMonitor?project="+project, cb)
}
function uploadContractDocument(contractId, name, data, type, cb){
    post("/customer-portal/contracts/"+contractId+"/uploadDocument", {
        name: name,
        data: data,
        type: type
    }, cb)
}

function isMaintenance(cb) {
    get("/maintenance", cb)
}

function getContractsWithName(project, name, cb){
    var req = new XMLHttpRequest()
    req.open("GET", process.env.VUE_APP_BE_URL + "/rest/contracts?project="+project+"&name="+name)
    req.setRequestHeader('content-type', 'application/json')
    req.setRequestHeader('X-Auth-Token', 'Kvq10g5nB2V4Q9cYsZ7hzG3D9e2wXaTf4P8kIuM6xV3RlYoNjQ8vU7mC4bXw2p0O3n1S6a5z')
    req.withCredentials = true
    req.addEventListener('load', function (event) {
        try {
            let response = JSON.parse(req.responseText)
            cb(response, req.status)
        } catch (e) {
            cb(false, req.status)
        }
    })
    req.onerror = function (event) {
        cb(false, false)
    }
    req.send()
}

function requestPickupChange(change, cb) {
    post("/attendance/pickupChange", change, cb)
}

function requestPickupChangeWithFile(formData, cb) {
    postFile("/attendance/pickupChange", formData, cb)
}

function getPickupChangeRequests(cb) {
    get("/attendance/requests", cb)
}

function getCustomerData(cb){
    get("/customer-portal", cb)
}

function saveCustomerData(data, cb){
    put("/customer-portal", data, cb)
}

function getBookableProjects(cb){
    get("/projects", cb)
}
function getBookableProject(id,cb){
    get("/projects/"+id+"", cb)
}

function bookProject(project, data, cb){
    post("/projects/"+project+"/book", data, cb)
}
function getContracts(cb){
    get("/customer-portal/contracts", cb)
}

function cancelContract(id, cb){
    post("/customer-portal/contracts/"+id+"/cancel", {}, cb)
}

function getAnnouncements(cb){
    get("/announcements", cb)
}

function getPollsForContract(contract, cb){
    get("/customer-portal/contracts/"+contract+"/polls", cb)
}

function answerPolls(contract, polls, cb){
    post("/customer-portal/contracts/"+contract+"/polls", polls, cb)
}

function getPollByPollId(pollId, cb){
    get("/customer-portal/polls/"+pollId, cb)
}

function updateContract(contract,cb){
    put("/customer-portal/contracts/"+contract.id, contract, cb)
}

function getRemainingMeals(project,cb){
    get("/remainingMeals?project="+project, cb)
}

function deleteAccount(cb){
    post("/customer-portal/delete", {}, cb)
}

function getEhrenamtStatus(cb){
    get("/ehrenamt/status", cb)
}

function requestEhrenamtAccess(cb){
    post("/ehrenamt/request", {}, cb)
}

function getEhrenamtProjects(cb){
    get("/ehrenamt/projects", cb)
}

function requestEhrenamtParticipation(projectId, compensation, cb){
    post("/ehrenamt/participation", { projectId: projectId, compensation: compensation }, cb)
}

function getEhrenamtParticipationRequests(cb){
    get("/ehrenamt/participation/requests", cb)
}

function getEhrenamtForms(cb){
    get("/ehrenamt/forms", cb)
}

function submitEhrenamtForm(data, cb){
    post("/ehrenamt/forms/submit", data, cb)
}

export default {
    getMealPlanConfig,
    deleteAccount,
    uploadContractDocument,
    getMealsForWeek,
    isMaintenance,
    getRemainingMeals,
    getMailCode,
    oidcLogin,
    mailCodeLogin,
    checkUser,
    getCards,
    checkRFID,
    logout,
    usesPasswordLogin,
    mailPasswordLogin,
    getQRCode,
    getMealPlanForWeek,
    getEatingContracts,
    saveMealPlanForWeek,
    getContractsWithName,
    getPickupContracts,
    requestPickupChange,
    requestPickupChangeWithFile,
    getPickupChangeRequests,
    getMealPlanForMonitor,
    getCustomerData,
    saveCustomerData,
    getBookableProjects,
    bookProject,
    getContracts,
    getBookableProject,
    cancelContract,
    getAnnouncements,
    getPollsForContract,
    answerPolls,
    getPollByPollId,
    updateContract,
    getEhrenamtStatus,
    requestEhrenamtAccess,
    getEhrenamtProjects,
    requestEhrenamtParticipation,
    getEhrenamtParticipationRequests,
    getEhrenamtForms,
    submitEhrenamtForm
}

function generateRequestId(message) {
    let hashValue = 0
    for (let i = 0; i < message.length; i++) {
        let charCode = message.charCodeAt(i);
        hashValue = ((hashValue << 5) - hashValue) + charCode;
        hashValue = hashValue & hashValue; // Ensure 32-bit integer limit
    }

    hashValue = hashValue >>> 0; // Convert to unsigned 32-bit integer
    console.log(hashValue.toString(16));
    return hashValue.toString(16);
}